import { faRocketLaunch } from '@fortawesome/pro-light-svg-icons';
import { memo } from 'react';
import { injectIntl } from 'react-intl';
import {
  Banner,
  BannerContent,
  BannerHeadlineMain,
  BannerHeadlineSub,
  RocketContainer,
  RocketDisplay,
} from './styles';

function BannerSection() {
  return (
    <Banner>
      <BannerContent>
        <RocketContainer>
          <RocketDisplay icon={faRocketLaunch} />
        </RocketContainer>
        <h2>
          <BannerHeadlineMain>Candidate Engagement</BannerHeadlineMain>
          <BannerHeadlineSub>on rocket fuel.</BannerHeadlineSub>
        </h2>
      </BannerContent>
    </Banner>
  );
}

export default injectIntl(memo(BannerSection));
